module.exports = __webpack_public_path__ + "img/ringcentral.d66c764f.png";